var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "location-filter",
      class: {
        "location-filter--defaulted":
          (_vm.location || {}).id === (_vm.defaultLocation || {}).id
      }
    },
    [
      _c("span", { staticClass: "icon-location-marker" }),
      _vm._v(" "),
      _c("span", { staticClass: "location-filter__near" }, [
        _vm._v(_vm._s(_vm.locationFilterCopy))
      ]),
      _vm._v(" "),
      _c(
        "CoreLocation",
        {
          attrs: {
            "data-e2e-component": "core-location",
            "current-location": _vm.defaultLocation,
            "current-location-label": _vm.$config.defaultLocation
              ? _vm.$config.defaultLocation.city +
                ", " +
                _vm.$config.defaultLocation.subdivision_code
              : "Current Location",
            placeholder: "Select Location",
            "selected-location": _vm.location
          },
          on: {
            error: function($event) {
              _vm.$emit("error")
            },
            select: function($event) {
              _vm.$emit("select", $event)
            }
          },
          scopedSlots: _vm._u([
            {
              key: "location",
              fn: function(ref) {
                var location = ref.location
                return [
                  location.subdivision_code
                    ? _c("span", [
                        _vm._v(
                          _vm._s(location.city) +
                            ", " +
                            _vm._s(location.subdivision_code)
                        )
                      ])
                    : _c("span", [_vm._v(_vm._s(location.city))])
                ]
              }
            }
          ])
        },
        [
          _c("span", {
            staticClass: "icon-chevron-lg-down",
            attrs: { slot: "caret" },
            slot: "caret"
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }